import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import { useUrlSearch } from '@/search';

import getAxiosConfig from '../helpers/getAxiosConfig';
import getCurrentTreeContentTransform from '../helpers/getCurrentTreeContentTransform';
import handleVideoUnauthorizedError from '../helpers/handleVideoUnauthorizedError';

export default ({ isEnabled = true } = {}) => {
  const { id, orgId } = useParams();
  const urlSearch = useUrlSearch();
  const videoId = urlSearch.getValue('version_id') || id;

  const videoComposeListKey = useMemo(() => ['videoComposeList', videoId], [videoId]);
  const videoComposeList = useQuery(
    videoComposeListKey,
    async () => {
      try {
        const { data } = await axios(getAxiosConfig('get-video-compose-list', { id: videoId }));
        return getCurrentTreeContentTransform({
          data,
          isLiveVideo: true,
          isAgenda: true,
        });
      } catch (error) {
        handleVideoUnauthorizedError({
          error,
          orgId,
          type: 'live',
          conditionedQueryCache: videoComposeList,
        });
        return {};
      }
    },
    { enabled: isEnabled, placeholderData: { items: [] } },
  );

  return { videoComposeList, videoComposeListKey };
};
